import { render, staticRenderFns } from "./UnitTransferReport.vue?vue&type=template&id=bfccfc82&scoped=true&"
import script from "./UnitTransferReport.vue?vue&type=script&lang=js&"
export * from "./UnitTransferReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfccfc82",
  null
  
)

export default component.exports